import moment from "moment"

export const getServiceWorkerUrl = () => {
  const version = moment().format("DD-MM-yyyy-HH")
  return `${process.env.PUBLIC_URL}/service-worker.js?v=${version}`
}
